import { render, staticRenderFns } from "./form_customer_format.vue?vue&type=template&id=169c55f7&scoped=true&"
import script from "./form_customer_format.vue?vue&type=script&lang=js&"
export * from "./form_customer_format.vue?vue&type=script&lang=js&"
import style0 from "./form_customer_format.vue?vue&type=style&index=0&id=169c55f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c55f7",
  null
  
)

export default component.exports